import "core-js/modules/es.array.includes.js";
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "mg-dropdown-menu-link-prefix"
};
const _hoisted_2 = {
  class: "mg-dropdown-menu-icon"
};
const _hoisted_3 = {
  class: "mg-dropdown-menu-link-content"
};
const _hoisted_4 = {
  class: "mg-dropdown-menu-link-suffix"
};
const _hoisted_5 = {
  key: 0,
  class: "vxe-icon-arrow-down"
};
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import { MgMenu } from '@/components/mgui/navigation/menu-v2/index';
export default {
  __name: 'mg-dropdown-menu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'button',
      validator: val => val == null || ['', 'text', 'button'].includes(val)
    },
    status: {
      type: String,
      default: null,
      validator: val => val == null || ['' | 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'error' | 'perfect'].includes(val)
    },
    transfer: {
      type: Boolean,
      default: true
    },
    trigger: {
      type: String,
      default: 'button',
      validator: val => ['hover', 'click', 'button'].includes(val)
    },
    popAlign: {
      type: String,
      default: 'right',
      validator: val => ['left', 'right'].includes(val)
    }
  },
  emits: ['click', 'item-click', 'item-hover', 'hover', 'outside-click'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const isOpen = ref(false);
    const selfRef = ref();
    const clientRect = ref();
    const dropdownRef = ref();
    const dropdownRect = ref();
    const enterTimeout = ref();
    const resizeObserverRef = ref();
    const dropdownStyle = computed(() => {
      if (!clientRect.value) return {};
      const {
        left,
        bottom
      } = clientRect.value;
      const scrollTop = window.scrollY;
      const scrollLeft = window.scrollX;
      return {
        top: `${bottom + scrollTop - 1}px`,
        left: `${left + scrollLeft}px`
      };
    });
    const customPopAlign = ref(props.popAlign);
    const updateClientRect = () => {
      if (!selfRef.value) return;
      clientRect.value = selfRef.value.getBoundingClientRect();
    };
    const clearResizeObserver = () => {
      if (resizeObserverRef.value) {
        // 销毁之前的监听器
        resizeObserverRef.value.disconnect();
        resizeObserverRef.value = null;
      }
    };
    const updateDropdownRect = () => {
      clearResizeObserver();
      if (dropdownRef.value) {
        resizeObserverRef.value = new ResizeObserver(els => {
          const winWidth = window.innerWidth;
          dropdownRect.value = dropdownRef.value.getBoundingClientRect() || null;
          if (props.popAlign === 'right' && clientRect.value && dropdownRect.value) {
            const {
              left,
              ...more
            } = clientRect.value;
            const {
              width: dropdownWidth
            } = dropdownRect.value;
            if (left + dropdownWidth + 100 > winWidth) {
              customPopAlign.value = 'left';
              clientRect.value = {
                left: winWidth - dropdownWidth,
                ...more
              };
            } else {
              customPopAlign.value = props.popAlign;
            }
          }
        });
        resizeObserverRef.value.observe(dropdownRef.value);
      }
    };
    const toggleDropdown = () => {
      isOpen.value = !isOpen.value;
      if (isOpen.value) {
        nextTick(() => {
          updateDropdownRect();
        });
      }
    };
    const openDropdown = () => {
      isOpen.value = true;
      nextTick(() => {
        updateDropdownRect();
      });
    };

    // eslint-disable-next-line
    const hideDropdown = () => {
      isOpen.value = false;
    };
    const handleClick = e => {
      if (props.trigger === 'click') {
        toggleDropdown();
      }
      emit('click', e);
    };
    const handleMouseenter = e => {
      if (props.trigger === 'hover') {
        openDropdown();
      }
      emit('hover', {
        isHover: true,
        $event: e
      });
    };
    onUnmounted(() => {
      if (enterTimeout.value) {
        clearTimeout(enterTimeout.value);
        enterTimeout.value = 0;
      }
    });
    const handleMouseleave = e => {
      if (props.trigger === 'hover') {
        // hideDropdown();
        if (enterTimeout.value) {
          clearTimeout(enterTimeout.value);
        }
        enterTimeout.value = setTimeout(() => {
          enterTimeout.value = 0;
          isOpen.value = false; // 超时未进入
        }, 100);
      }
      emit('hover', {
        isHover: false,
        $event: e
      });
    };
    const handleItemClick = ({
      item,
      $event
    }) => {
      isOpen.value = false;
      emit('item-click', {
        item,
        $event
      });
    };
    const handleItemHover = ({
      item,
      isHover,
      $event
    }) => {
      if (props.trigger === 'hover') {
        if (isHover) {
          // 清空定时器
          if (enterTimeout.value) {
            clearTimeout(enterTimeout.value);
            enterTimeout.value = 0;
          }
          openDropdown();
        } else {
          hideDropdown();
        }
      }
      emit('item-hover', {
        item,
        isHover,
        $event
      });
    };
    const handleOutsideClick = e => {
      if (!selfRef.value) return;
      if (!selfRef.value.contains(e.target)) {
        // outside click
        if (['click', 'button'].includes(props.trigger) && isOpen.value) {
          isOpen.value = false;
        }
        emit('outside-click', e);
      }
    };
    const handleDropdownClick = e => {
      if (props.trigger === 'button') {
        toggleDropdown();
      }
    };
    onMounted(() => {
      updateClientRect();
      document.addEventListener('click', handleOutsideClick);
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleOutsideClick);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['mg-dropdown-menu', __props.className, {
          'is--open': isOpen.value
        }, {
          'is--disabled': __props.disabled
        }, {
          'button--mode': props.mode === 'button',
          'text--mode': props.mode === 'text'
        }]),
        onMouseenter: _withModifiers(handleMouseenter, ["stop"]),
        onMouseleave: _withModifiers(handleMouseleave, ["stop"]),
        onClick: handleClick
      }, [_createElementVNode("a", {
        ref_key: "selfRef",
        ref: selfRef,
        class: _normalizeClass(['mg-dropdown-menu-link', {
          'status--primary': __props.status === 'primary',
          'status--success': __props.status === 'success',
          'status--warning': __props.status === 'warning',
          'status--danger': __props.status === 'danger',
          'status--info': __props.status === 'info',
          'status--perfect': __props.status === 'perfect'
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_renderSlot(_ctx.$slots, "prefix", {}, () => [_createElementVNode("i", {
        class: _normalizeClass(__props.icon)
      }, null, 2)])])]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.title), 1)])]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "suffix", {}, () => [props.trigger !== 'button' ? (_openBlock(), _createElementBlock("i", _hoisted_5)) : _createCommentVNode("", true)])]), props.trigger === 'button' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mg-dropdown-menu-btn",
        onClick: handleDropdownClick
      }, [...(_cache[0] || (_cache[0] = [_createElementVNode("i", {
        class: "vxe-icon-arrow-down"
      }, null, -1)]))])) : _createCommentVNode("", true)], 2), (_openBlock(), _createBlock(_Teleport, {
        disabled: !__props.transfer,
        to: "#app"
      }, [_createElementVNode("div", {
        class: _normalizeClass(['mg-dropdown-menu-dropdown-wrapper', {
          'is--open': isOpen.value
        }]),
        style: _normalizeStyle(dropdownStyle.value)
      }, [_createElementVNode("div", {
        ref_key: "dropdownRef",
        ref: dropdownRef,
        class: "mg-dropdown-menu-links-wrapper"
      }, [_createVNode(_unref(MgMenu), {
        items: __props.items,
        "is-active": isOpen.value,
        "pop-align": customPopAlign.value,
        onItemClick: handleItemClick,
        onItemHover: handleItemHover
      }, null, 8, ["items", "is-active", "pop-align"])], 512)], 6)], 8, ["disabled"]))], 34);
    };
  }
};